var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureTopMatch = function SvgFeatureTopMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M9.824 12.653H8.748a1.402 1.402 0 0 1-1.402-1.402v-1.076a.602.602 0 0 0-.175-.424l-.76-.76a1.402 1.402 0 0 1 0-1.983l.76-.76a.597.597 0 0 0 .176-.424V4.748c0-.774.628-1.402 1.402-1.402h1.075c.16 0 .312-.063.425-.175l.76-.76a1.402 1.402 0 0 1 1.983 0l.76.76a.599.599 0 0 0 .424.175h1.076c.774 0 1.402.628 1.402 1.402v1.076c0 .159.063.311.175.424l.76.76a1.402 1.402 0 0 1 0 1.983l-.76.76a.6.6 0 0 0-.175.425v1.076c0 .774-.628 1.402-1.402 1.402h-1.076a.602.602 0 0 0-.424.175l-.76.76a1.402 1.402 0 0 1-1.983 0l-.76-.76a.6.6 0 0 0-.425-.176",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8.56 12.268a.625.625 0 0 1 .374.8l-2.338 6.427.987-.604a.625.625 0 0 1 .914.322l.428 1.192 2.359-6.481a.625.625 0 0 1 1.174.427l-2.95 8.107a.625.625 0 0 1-1.176-.003l-.752-2.097-1.857 1.136a.625.625 0 0 1-.914-.747l2.95-8.106a.625.625 0 0 1 .802-.373",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.883 13.467a.625.625 0 0 1 .801.373l2.365 6.497.364-1.103a.625.625 0 0 1 .91-.342l1.096.646-2.386-6.553a.625.625 0 0 1 1.175-.428l2.981 8.191a.625.625 0 0 1-.905.752l-1.927-1.137-.685 2.077a.625.625 0 0 1-1.181.018l-2.981-8.19a.625.625 0 0 1 .373-.802",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureTopMatch;